/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Autocomplete,
  Button,
  TableBody,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Card,
  FormControlLabel,
  Typography,
  FormControl,
  MenuItem,
  Grid,
  Checkbox,
} from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PropTypes from 'prop-types';
import _ from 'lodash';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import GoldPrice2Form from './GoldPrice2Form';
import { ImageUpload } from '../../ImageUpload';

dayjs.locale('th');

const formatNumber = (value) => {
  if (!value && value !== 0) return '';
  const strValue = value.toString();
  if (!/^\d*\.?\d*$/.test(strValue)) return strValue;
  if (strValue.endsWith('.')) {
    const integerPart = Number(strValue.slice(0, -1)).toLocaleString();
    return integerPart + '.';
  }
  const parts = strValue.split('.');
  const integerPart = Number(parts[0]).toLocaleString();
  if (parts[1] !== undefined) {
    return integerPart + '.' + parts[1];
  }

  return integerPart;
};

const parseNumber = (value) => {
  if (!value && value !== 0) return 0;
  const cleanValue = value.toString().replace(/,/g, '');
  const numValue = Number(cleanValue);

  return isNaN(numValue) ? 0 : numValue;
};

const NumberField = ({ label, field, color = 'black', ...props }) => {
  const [displayValue, setDisplayValue] = useState(formatNumber(field.value));

  useEffect(() => {
    setDisplayValue(formatNumber(field.value));
  }, [field.value]);

  const handleChange = (e) => {
    const inputValue = e.target.value;

    if (inputValue === '' || /^[\d,]*\.?\d*$/.test(inputValue)) {
      setDisplayValue(inputValue);

      const numValue = parseNumber(inputValue);
      field.onChange(numValue);
    }
  };

  const handleBlur = () => {
    const formatted = formatNumber(field.value);
    setDisplayValue(formatted);
  };

  return (
    <TextField
      {...props}
      label={label}
      type="text"
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      sx={{
        '& .MuiInputBase-input': {
          color: color,
        },
        '& .MuiInputLabel-root': {
          color: color,
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: color,
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': { borderColor: color },
          '&:hover fieldset': { borderColor: color },
          '&.Mui-focused fieldset': { borderColor: color },
        },
        ...props.sx,
      }}
      variant="outlined"
      fullWidth
    />
  );
};

export function SaleProductform({
  listorder,
  material,
  setListorder,
  handleAddOrder,
  materialType,
  setPayment,
  me,
  setTotalListOrder,
  placeName,
  setPlace,
  setMaterialName,
  materialName,
  transactionDate,
  setTransactionDate,
  materialTypeId,
  setmaterialTypeId,
  materialTypeName,
  materialTypeVat,
  setMaterialUnit,
  setNoMaterial,
  setmaterialTypeName,
  setmaterialTypeVat,
  noteMaterial,
  setNoteMaterial,
  goldPrice,
  bank,
  bankList,
  cashList,
  image,
  setImage,
}) {
  const resetValues = {
    quantity: 1,
    material: null,
    cashStatus: false,
    creditStatus: false,
    transferStatus: false,
    cashAmount: 0,
    credit: 0,
    tranfer: 0,
    price: 0,
    cost: 0,
    weight: 0,
    lot_number: '',
    price_gold: 0,
  };

  const [reload, setReload] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [showGoldAlert, setShowGoldAlert] = useState(false);
  const [pendingProduct, setPendingProduct] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState({
    material: false,
    cash: false,
    transfer: false,
    credit: false,
    note: false,
  });

  const GoldSellBar = parseFloat(
    (goldPrice?.price?.gold_bar?.buy || '').replace(/,/g, ''),
  );

  const { control, watch, setValue, reset, getValues, handleSubmit } = useForm({
    defaultValues: { ...resetValues, price_gold: GoldSellBar || 0 },
  });

  const totalCostListOrder = _.sumBy(
    listorder,
    (item) => Number(item.cost) || 0,
  );
  const remain =
    totalCostListOrder -
    (Number(watch('cash.amount')) || 0) -
    (Number(watch('transfer.amount')) || 0) -
    (Number(watch('credit.amount')) || 0);

  // Filter materials: exclude items where weight is 0
  const filteredMaterials =
    material?.rows?.filter((item) => item?.weight > 0) || [];
  const selectedBank = watch('transfer.bank');
  const transferAmount = Number(watch('transfer.amount') || 0);
  const cashAmount = Number(watch('cash.amount') || 0);
  useEffect(() => {
    setValue('price_gold', GoldSellBar || 0);
  }, [GoldSellBar, setValue]);

  useEffect(() => {
    setTotalListOrder(totalCostListOrder);
  }, [totalCostListOrder, setTotalListOrder]);

  useEffect(() => {
    setPayment({
      cashStatus: selectedOptions.cash,
      cash: getValues('cash.amount') || 0,
      credit: getValues('credit.amount') || 0,
      creditStatus: selectedOptions.credit || false,
      transfer: getValues('transfer.amount') || 0,
      transferStatus: selectedOptions.transfer || false,
      bank: getValues('transfer.bank') || '',
    });
  }, [
    watch('cash.amount'),
    watch('transfer.amount'),
    watch('credit.amount'),
    selectedOptions,
  ]);

  const handleOptionChange = (event) => {
    const { name, checked } = event.target;
    setSelectedOptions((prev) => ({ ...prev, [name]: checked }));
  };

  const handleContinueAlert = () => {
    setShowGoldAlert(false);
    if (pendingProduct) {
      listorder.push(pendingProduct);
      setListorder(listorder);
      setPendingProduct(null);
      resetForm();
    }
  };

  const resetForm = () => {
    reset({ ...resetValues, material: null, price_gold: GoldSellBar });
    setSelectedOptions({
      material: false,
      cash: false,
      transfer: false,
      credit: false,
      note: false,
    });
    setResetKey((prev) => prev + 1);
  };

  const handleRemoveMaterial = (index) => {
    listorder.splice(index, 1);
    setListorder(listorder);
    setReload(!reload);
  };

  const checkPlaceName = (option) => {
    const mapping = {
      คลังรูปพรรณเก่า: 'เก่า',
      คลังรูปพรรณใหม่: 'ใหม่',
    };
    return mapping[option?.place?.name] || ' คลังอื่นๆ';
  };

  const handleAddProduct = () => {
    const values = getValues();

    if (
      !values.material ||
      !values.quantity ||
      !values.weight ||
      !values.cost ||
      !values.price_gold
    ) {
      window.alert('กรุณาใส่ข้อมูลให้ครบถ้วน');
      return;
    }

    const selectedMaterial = values.material;
    const quantity = Number(values.quantity);
    const weight = Number(values.weight);

    const availableWeight = Number(selectedMaterial?.weight || 0);
    console.log('availableWeight', availableWeight);
    console.log('weight', weight);

    const usedWeightInOrder = listorder
      .filter((item) => item.material === selectedMaterial?._id)
      .reduce((sum, item) => sum + Number(item.weight || 0), 0);

    // 🔹 น้ำหนักคงเหลือจริง
    const remainingWeight = availableWeight - usedWeightInOrder;

    console.log('usedWeightInOrder', usedWeightInOrder);
    console.log('remainingWeight', remainingWeight);

    if (weight > remainingWeight) {
      alert(
        `น้ำหนักคงเหลือในคลัง ${remainingWeight.toFixed(
          3,
        )} กรัม (ใช้ไปแล้ว ${usedWeightInOrder.toFixed(2)} กรัม)`,
      );
      return;
    }

    const costPrice = Number(values.cost) || 0;
    const currentGoldPrice = Number(values.price_gold) || 0;
    const currentWeight = Number(values.weight) || 0;

    let imageData = null;
    if (!_.isEmpty(image) && image?.[0]?.data_url) {
      imageData = {
        image: image[0].data_url,
        imageType: 'orderImage',
        alt: '',
      };
    }

    const data = {
      material: values.material?._id,
      materialname: materialName,
      isGoldbar: values.material?.isbar,
      note: values.note || '',
      materialTypeName: materialTypeName,
      materialTypeVat: materialTypeVat,
      materialTypeId: materialTypeId,
      price: values.price || 0,
      place: placeName,
      lot_number: values.lot_number || '',
      gold_official: currentGoldPrice || 0,
      weight: weight,
      quantity: quantity,
      cost: values.cost || 0,
      price_gold: currentGoldPrice,
      ...(imageData && { image: imageData }),
    };

    if (costPrice < (currentGoldPrice / 15.16) * currentWeight) {
      setPendingProduct(data);
      setShowGoldAlert(true);
      return;
    }

    listorder.push(data);
    setListorder(listorder);
    resetForm();
  };

  const renderAddProductForm = () => (
    <Card>
      <form onSubmit={handleSubmit(handleAddProduct)}>
        <div className="px-6 pt-4">
          <Typography variant="h6" gutterBottom>
            <div className="text-xl font-bold text-green-600 pl-2">
              เพิ่มสินค้าที่ขาย
            </div>
          </Typography>

          <div className="py-2">
            <FormControl fullWidth>
              <Controller
                key={resetKey}
                name="material"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    {...field}
                    fullWidth
                    options={filteredMaterials}
                    getOptionLabel={(option) =>
                      `${option?.name}${checkPlaceName(option)} (${
                        option?.material_type?.name
                      })`
                    }
                    renderOption={(props, option) => (
                      <MenuItem
                        {...props}
                        className="!flex !flex-col !items-start sm:!flex-row sm:!items-center !w-full !py-4 !px-5"
                      >
                        <div className="flex-1 w-full sm:w-auto">
                          <div className="font-medium text-lg mb-2 sm:mb-1">
                            {option?.name}
                            {checkPlaceName(option)} (
                            {option?.material_type?.name})
                          </div>
                        </div>
                      </MenuItem>
                    )}
                    onChange={(e, value) => {
                      field.onChange(value);
                      setMaterialName(value?.name);
                      setmaterialTypeName(value?.material_type?.name);
                      setmaterialTypeVat(value?.material_type?.vat);
                      setPlace(value?.place?.name);
                      setNoMaterial(value?._id);
                      setmaterialTypeId(value?.material_type?._id);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        label="สินค้า"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: 'black' },
                            '&:hover fieldset': { borderColor: 'black' },
                            '&.Mui-focused fieldset': { borderColor: 'black' },
                          },
                          '& label.Mui-focused': { color: 'black' },
                        }}
                      />
                    )}
                  />
                )}
              />
            </FormControl>

            <div className="flex items-center space-x-2 mt-2">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedOptions.note}
                    onChange={handleOptionChange}
                    name="note"
                  />
                }
                label="หมายเหตุ"
              />
              {selectedOptions.note && (
                <div className="w-1/2">
                  <Controller
                    control={control}
                    name="note"
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="outlined"
                        size="small"
                        onChange={(e) => {
                          field.onChange(e);
                          setNoteMaterial(e.target.value);
                        }}
                      />
                    )}
                  />
                </div>
              )}
            </div>
          </div>

          {placeName === 'คลังอื่นๆ' ? (
            <div className="grid grid-cols-2 gap-2">
              <Controller
                name="weight"
                control={control}
                render={({ field }) => (
                  <NumberField label="จำนวน (ชิ้น)" field={field} />
                )}
              />
            </div>
          ) : (
            <div className="grid grid-cols-2 gap-2">
              <Controller
                name="weight"
                control={control}
                render={({ field }) => (
                  <NumberField label="น้ำหนัก(กรัม)" field={field} />
                )}
              />
              <Controller
                name="quantity"
                control={control}
                defaultValue={1}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="จำนวน"
                    type="number"
                    InputProps={{ readOnly: true }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': { borderColor: 'black' },
                        '&:hover fieldset': { borderColor: 'black' },
                        '&.Mui-focused fieldset': { borderColor: 'black' },
                      },
                      '& label.Mui-focused': { color: 'black' },
                    }}
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </div>
          )}

          <div className="grid grid-cols-2 gap-2 py-2">
            <Controller
              name="cost"
              control={control}
              render={({ field }) => (
                <NumberField label="มูลค่า" field={field} />
              )}
            />
            <Controller
              name="price_gold"
              control={control}
              render={({ field }) => (
                <NumberField
                  label="ราคาทองแท่งขายออก"
                  field={field}
                  inputProps={{ step: '0.01' }}
                  sx={{
                    '& .MuiInputLabel-root': {
                      color: 'green',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: 'green',
                    },
                    '& .MuiInputBase-input': {
                      color: 'green',
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: 'green',
                      },
                      '&:hover fieldset': {
                        borderColor: 'green',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: 'green',
                      },
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="w-full px-1 py-2">
            <ImageUpload images={image} maxNumber={1} setImages={setImage} />
          </div>
          <div className="py-2 text-center">
            <Button
              variant="contained"
              color="success"
              type="button"
              sx={{ fontSize: '1.2rem', padding: '14px 28px' }}
              onClick={handleAddProduct}
            >
              เพิ่มสินค้าที่ขาย
            </Button>
          </div>
        </div>
      </form>
    </Card>
  );

  const renderOrderList = () => (
    <div className="md:px-6 xl:pt-4">
      <div className="text-xl text-center pb-1">รายการสินค้าที่ขาย</div>
      <Card>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                {[
                  'ลำดับ',
                  'ชื่อสินค้า',
                  'คลังสินค้า',
                  'น้ำหนัก(กรัม)',
                  'จำนวน',
                  'มูลค่า(บาท)',
                  'วันที่',
                  'ดำเนินการ',
                ].map((header) => (
                  <TableCell
                    key={header}
                    align="center"
                    style={{ backgroundColor: '#f5f5f5' }}
                  >
                    <div className="text-black">{header}</div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {!_.isEmpty(listorder) ? (
                listorder.map((product, index) => {
                  const findMaterial = _.find(material?.rows, {
                    _id: product?.material,
                  });
                  return (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <div>{findMaterial?.name}</div>
                        <span>({findMaterial?.material_type?.name})</span>
                      </TableCell>
                      <TableCell>{findMaterial?.place?.name}</TableCell>
                      <TableCell>{formatNumber(product?.weight)}</TableCell>
                      <TableCell>{formatNumber(product?.quantity)}</TableCell>
                      <TableCell>{formatNumber(product?.cost)} บาท</TableCell>
                      <TableCell>
                        {transactionDate
                          ? dayjs(transactionDate).format('DD/MM/YYYY')
                          : dayjs().format('DD/MM/YYYY')}
                      </TableCell>
                      <TableCell>
                        <Button
                          color="error"
                          variant="contained"
                          size="small"
                          onClick={() => handleRemoveMaterial(index)}
                        >
                          ลบ
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <div className="text-center">ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="text-center p-2">
          ยอดรวม {formatNumber(totalCostListOrder) || 0} บาท
        </div>
      </Card>
    </div>
  );

  const renderPaymentForm = () => (
    <div className="xl:pl-6">
      <Card>
        <div className="p-2 items-center text-center">
          <FormControl
            component="fieldset"
            sx={{ display: 'flex', justify: 'center', width: '100%' }}
          >
            <Typography variant="h6" align="center" gutterBottom>
              เลือกการชำระเงิน
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.cash}
                      onChange={handleOptionChange}
                      name="cash"
                    />
                  }
                  label={`เงินสด (คงเหลือ ${
                    cashList?.[0]?.currentAmount?.toLocaleString() || 0
                  } บาท)`}
                />

                {selectedOptions.cash && (
                  <Controller
                    control={control}
                    name="cash.amount"
                    render={({ field }) => (
                      <NumberField label="จำนวนเงิน" field={field} />
                    )}
                  />
                )}
              </Grid>

              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.transfer}
                      onChange={handleOptionChange}
                      name="transfer"
                    />
                  }
                  label="โอนเงิน"
                />
                {selectedOptions.transfer && (
                  <>
                    <Controller
                      control={control}
                      name="transfer.bank"
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          options={bankList}
                          getOptionLabel={(option) =>
                            `${option.bankName} (${option.accountNumber}) - ${option.name}`
                          }
                          // ⭐⭐ Disable เมื่อ currentAmount < remain
                          onChange={(_, data) => field.onChange(data)}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="เลือกบัญชีธนาคาร"
                              variant="outlined"
                              size="small"
                              fullWidth
                              sx={{ mt: 1 }}
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option._id === value?._id
                          }
                        />
                      )}
                    />

                    <Controller
                      control={control}
                      name="transfer.amount"
                      render={({ field }) => (
                        <NumberField label="จำนวนเงิน" field={field} />
                      )}
                    />
                  </>
                )}
              </Grid>

              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedOptions.credit}
                      onChange={handleOptionChange}
                      name="credit"
                    />
                  }
                  label="เครดิต"
                />
                {selectedOptions.credit && (
                  <Controller
                    control={control}
                    name="credit.amount"
                    render={({ field }) => (
                      <NumberField label="จำนวนเงิน" field={field} />
                    )}
                  />
                )}
              </Grid>
            </Grid>

            <div
              className={`font-bold text-lg ${
                remain < 0 ? 'text-green-600' : 'text-red-600'
              }`}
            >
              {remain < 0 ? (
                <div>จ่ายเงินเกิน {formatNumber(Math.abs(remain))} บาท</div>
              ) : remain === 0 ? (
                <div className="text-green-600">ชำระเงินครบถ้วน</div>
              ) : (
                <div>ต้องจ่ายอีก {formatNumber(remain)} บาท</div>
              )}
            </div>
          </FormControl>
        </div>
      </Card>
    </div>
  );

  // ช่วยฟังก์ชันเพิ่ม
  const isToday = (d) => dayjs.isDayjs(d) && d.isSame(dayjs(), 'day');

  // ฟังก์ชันเช็กช่วงห้าม
  const isForbidden = (d) => {
    if (!d || !dayjs.isDayjs(d) || !d.isValid()) return false;
    const h = d.hour();
    const m = d.minute();

    if (isToday(d)) {
      // วันนี้: ห้าม 23:30–00:30 (เหมือนเดิม)
      const inLateWindow = h === 23 && m >= 30; // 23:30–23:59
      const inEarlyWindow = h === 0 && m <= 30; // 00:00–00:30
      return inLateWindow || inEarlyWindow;
    }

    // ไม่ใช่วันนี้: อนุญาตเฉพาะ 07:00–23:30
    if (h < 7) return true; // ก่อน 07:00
    if (h > 23) return true; // เลย 23 ชั่วโมง (กรณีแปลก)
    if (h === 23 && m > 30) return true; // หลัง 23:30
    return false;
  };

  // (ทางเลือก) เลื่อนเวลาให้อยู่ในช่วงอนุญาตอัตโนมัติ
  const snapToAllowed = (d) => {
    if (!d || !dayjs.isDayjs(d) || !d.isValid()) return d;
    if (!isForbidden(d)) return d;

    const h = d.hour();
    const m = d.minute();

    if (isToday(d)) {
      // วันนี้: ถ้าอยู่ฝั่งก่อนเที่ยงคืนให้ snap เป็น 23:29:59, ถ้าหลังเที่ยงคืนให้ 00:31:00
      if (h === 23) return d.minute(29).second(59);
      return d.hour(0).minute(31).second(0);
    } else {
      // ไม่ใช่วันนี้: บังคับอยู่ใน 07:00–23:30
      if (h < 7) return d.hour(7).minute(0).second(0);
      if (h > 23 || (h === 23 && m > 30))
        return d.hour(23).minute(30).second(0);
      return d; // เผื่อกรณีอื่น
    }
  };

  return (
    <div className="container mx-auto">
      {showGoldAlert && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
          <div className="bg-white p-6 rounded shadow-lg text-center">
            <div className="mb-4 text-lg font-bold text-red-600">
              ราคาทองคำที่ขาย {formatNumber(getValues('cost'))} บาท
              ต่ำกว่าราคาทองต่อกรัม{' '}
              {Number(
                (getValues('price_gold') / 15.16) * getValues('weight'),
              )?.toLocaleString('th-TH', {
                minimumFractionDigits: 3,
                maximumFractionDigits: 3,
              })}{' '}
              บาท
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={handleContinueAlert}
            >
              ทำรายการต่อ
            </Button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <div className="space-y-6">
          <div className="rounded-lg w-full px-4 xl:pt-2">
            <GoldPrice2Form buy={false} />
          </div>
          {me?.userData?.department?.access?.OTHER?.dateBuy && (
            <div className="bg-white rounded-lg p-4">
              <div className="flex items-center justify-between">
                <Typography variant="h6" className="text-nowrap">
                  วันที่ทำรายการ
                </Typography>
                <div>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDateTimePicker
                      label="วันที่และเวลาทำรายการ"
                      value={transactionDate}
                      onChange={(newValue) => {
                        if (
                          !newValue ||
                          !dayjs.isDayjs(newValue) ||
                          !newValue.isValid()
                        ) {
                          setTransactionDate(newValue);
                          return;
                        }
                        const snapped = snapToAllowed(newValue);

                        if (isForbidden(newValue)) {
                          alert(
                            isToday(newValue)
                              ? 'ระบบปรับเวลาให้อยู่ในช่วงที่อนุญาต (วันนี้ห้าม 23:30–00:30)'
                              : 'ระบบปรับเวลาให้อยู่ในช่วงที่อนุญาต (สำหรับวันที่ไม่ใช่วันนี้ เลือกได้เฉพาะ 07:00–23:30)',
                          );
                        }
                        setTransactionDate(snapped);
                      }}
                      format="DD/MM/YYYY HH:mm"
                      shouldDisableTime={(timeValue, view) => {
                        if (!timeValue || !dayjs.isDayjs(timeValue))
                          return false;

                        const thisIsToday = isToday(timeValue);
                        const h = timeValue.hour();
                        const m = timeValue.minute();

                        if (view === 'hours') {
                          if (!thisIsToday) {
                            // ไม่ใช่วันนี้: เปิดเฉพาะชั่วโมง 7..23
                            return h < 7 || h > 23;
                          }
                          // วันนี้: ไม่ปิดชั่วโมง (ให้ไปคุมระดับนาทีแทน)
                          return false;
                        }

                        if (view === 'minutes') {
                          if (!thisIsToday) {
                            // ไม่ใช่วันนี้: นาทีห้ามก่อน 07:00 และหลัง 23:30
                            if (h < 7) return true;
                            if (h === 23 && m > 30) return true;
                            if (h > 23) return true;
                            return false;
                          }
                          // วันนี้: ใช้กฎเดิมห้าม 23:30–00:30
                          return isForbidden(timeValue);
                        }

                        return false;
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          sx={{
                            width: 250,
                            '& .MuiOutlinedInput-root': {
                              '& fieldset': { borderColor: 'black' },
                              '&:hover fieldset': { borderColor: 'black' },
                              '&.Mui-focused fieldset': {
                                borderColor: 'black',
                              },
                            },
                            '& label.Mui-focused': { color: 'black' },
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>
          )}

          <div className="rounded-lg w-full">{renderAddProductForm()}</div>
        </div>
        <div className="bg-white rounded-lg w-full xl:mb-6 mt-2 py-4">
          {renderOrderList()}
        </div>
      </div>

      {!_.isEmpty(listorder) && (
        <div className="bg-white rounded-lg w-full xl:mb-6 mt-2 py-4">
          {renderPaymentForm()}
        </div>
      )}
    </div>
  );
}

SaleProductform.propTypes = {
  material: PropTypes.object,
  selectMaterial: PropTypes.object,
  setSelectMaterial: PropTypes.func,
  materialType: PropTypes.arrayOf(PropTypes.object),
  image: PropTypes.arrayOf(PropTypes.object),
  setImage: PropTypes.func,
};

SaleProductform.defaultProps = {
  material: null,
  selectMaterial: null,
};

export default SaleProductform;
